import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IBestSellers } from '../models/models'

export class ListMostSelledExceptionProductApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/listMostSelledExceptionProduct',
      requesterInfo,
    })
  }

  public async listMostSelledExceptionProduct(): Promise<IBestSellers[]> {
    return await this.getAsync<IBestSellers[]>()
  }
}
